// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1dW0z","inner":"Footer_inner__1QdiV","nextIcon":"Footer_nextIcon__152Po","innerLeft":"Footer_innerLeft__1AhBL"};